import { IcdOfficeModel } from "@herbjoy/apex-api-models";
import { IQService } from "angular";
import { IcdCorporationService, IcdCorporationStatus, IcdOfficeService } from "../../../core/services";

interface TargetOfficeValidationResult {
    isValid: boolean;
    icdOffice?: IcdOfficeModel;
    messages: string[];
}

export class MeridianIdMovementService {
    constructor(private $q: IQService, private icdOfficeService: IcdOfficeService,
        private icdCorporationService: IcdCorporationService) {
        'ngInject';
    }

    /**
     * Validate whether the given target office ID is valid for the transfer.
     * @param sourceIcdOfficeID The office ID for the office transferring its Meridian Office ID.
     * @param targetIcdOfficeID The office ID being selected for the target.
     */
    validateTargetIcdOffice(sourceIcdOfficeID: number, targetIcdOfficeID: number) {
        const result: TargetOfficeValidationResult = {
            isValid: true,
            messages: []
        };
        if (sourceIcdOfficeID === targetIcdOfficeID) {
            result.isValid = false;
            result.messages.push("Target office must not be the same as the source office");
            // Source and target must be different.
            return this.$q.resolve(result);
        }
        return this.icdOfficeService.retrieveIcdOffice(targetIcdOfficeID)
            .then(icdOffice => {
                result.icdOffice = icdOffice;
                if (result.icdOffice.MeridianOfficeID) {
                    result.isValid = false;
                    result.messages.push(`Target Office already has Meridian ID ${result.icdOffice.MeridianOfficeID}`
                        + ` assigned to it`);
                }
                return this.icdCorporationService.retrieveIcdCorporation(result.icdOffice.IcdCorporationID)
            })
            .then(icdCorporation => {
                if (icdCorporation.IcdCorporationStatusID === IcdCorporationStatus.Inactive) {
                    result.isValid = false;
                    result.messages.push(`Target Office must belong to an active corporation.`);
                }
            })
            .then(() => result);
    }
}
